import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type loginForgetPageContentDetailsInitialStateType = {
  loginForgetPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: loginForgetPageContentDetailsInitialStateType = {
  loginForgetPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "login-forget.json";

export const getLoginForgetPageContent = createAsyncThunk(
  "get/loginForget-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=v1&${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const loginForgetPageContentDetailSlice = createSlice({
  name: "loginForget-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLoginForgetPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLoginForgetPageContent.fulfilled, (state, action) => {
      state.loginForgetPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getLoginForgetPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "login AEM content",
        action.error?.message,
        action?.type
      );
      state.loginForgetPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default loginForgetPageContentDetailSlice.reducer;
